__turbopack_context__.v({
  "company": "Footer-module__EZoWya__company",
  "containers": "Footer-module__EZoWya__containers",
  "inside": "Footer-module__EZoWya__inside",
  "links": "Footer-module__EZoWya__links",
  "wrapper": "Footer-module__EZoWya__wrapper",
});
